<template>
<empty v-if="notfound" icon="not_listed_location" text="Helaas" description="We hebben dit restaurant niet gevonden. Klik hier om terug te gaan naar de startpagina." to="./"></empty>
<feature-card v-else-if="host && ($route.query && $route.query.show=='info' || $route.path.includes('/info') || $route.params.index == 'info')" :host="host"></feature-card>
  <v-sheet v-else-if="host" :dark="dark" class="fill-height" :color="!dark ? 'background' : null">
     <address-block popup 
              allow-delete :host="host"
              :show="showAddressBlock" :hide-hubs="true"
              @close="checkType();showAddressBlock = false"
              @select="setThisAddress"
              title="Selecteer je adres"
            >
           <template v-slot:buttons="{ close }">
             <v-btn color="grey" depressed
                  @click="type='takeaway';close();showMessage=false;showtakeAway=false;showAddressBlock=false"
                text>
                  Toch liever afhalen
                </v-btn>
             <v-spacer></v-spacer>
            <v-btn color="primary" depressed
                  @click="close();showMessage=false;showtakeAway=false;showAddressBlock=false"
                text v-if="address">
                  Selecteren
                </v-btn>
            </template>
            </address-block>
     
    
    <v-dialog
      :dark="dark"
      v-model="showProduct"
     :fullscreen="!largeScreen" scrollable
      hide-overlay
      >
      <product-detail v-model="product" v-if="product"
                    :list="products" :dark="dark"
                    @select="addItem" 
                    @extra="addExtraItem" :fullscreen="!largeScreen" scrollable :max-width="800"
                    @remove="removeCartItem"
                    @update="updateItem"
                    @close="product = null;showProduct = false;"
                    :focus="focusDescription"
                        
                      ></product-detail>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="timeout" color="primary">
      <span v-if="product">{{ product.name }} is toegevoegd</span>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="editItem(product)">
          Aanpassen
        </v-btn>
      </template>
    </v-snackbar>
    <page-header
      :collapse-toolbar="collapseToolbar && !largeScreen"
      :is-toolbar="isToolbar && !largeScreen"
      :banner="banner"
      :toolbar-title="title"
      :back="backUrl"
      :dark="dark"
      :align-end="true"
      :title="title"
      :host="host"
      :clip-right="true"
      @click="showDetails=!showDetails"
      :subtitle="opentext"
    >
      <template slot="hero">
       <div @click="showDetails=!showDetails" class="mb-5"> 
        <v-avatar v-if="hostitem.logo" class="app-btn mb-7" :size="largeScreen ? 90: 70" style="z-index:10;border:3px solid white;">
          <v-img :src="hostitem.logo"></v-img>
        </v-avatar>
       <!--h1 class="text-h5 white--text">{{ title }}<v-icon v-if="!showDetails" color="white">expand_more</v-icon>
                <v-icon v-else color="primary">expand_less</v-icon></h1-->
       </div>
        </template>
     <template slot="icon">
     <v-btn :class="{'app-btn' : isCourier}" :color="!isCourier ? 'transparent': null" :dark="!isCourier" depressed fab small v-if="courier" @click="toggleCourier">
        <v-icon v-if="isCourier">mdi-bike-fast</v-icon>
        <v-icon v-else color="grey">mdi-bike</v-icon>
      </v-btn>
      <v-btn class="app-btn" depressed fab small @click="toggleFavorite" v-if="user">
        <v-icon v-if="favorite">favorite</v-icon>
        <v-icon v-else>favorite_border</v-icon>
      </v-btn>
       
      </template>
      
    <v-toolbar dense flat slot="extension" :class="{'px-0': !largeScreen, 'pl-3 pr-7':  largeScreen}" >
       <v-btn class="app-btn mt-1" depressed fab small @click="showSearch = !showSearch" 
          ><v-icon>mdi-magnify</v-icon></v-btn
        >
       <v-text-field
          v-model="searchText"
          v-if="showSearch"
          value="" color="primary"
          placeholder="Waar heb je zin in"
          class="primary--text main-content"
          hide-details
          solo
          flat
          background-color="transparent"
          autofocus
          append-outer-icon="close"  
          @click:append-outer="searchText=null;showSearch = false"
        ></v-text-field>
        <template v-else>
          
            <v-chip-group v-model="tab" class="mr-3" 
            :class="{'ml-3': tabs.length==1}" 
            :column="!largeScreen" center-active :show-arrows="largeScreen"
            active-class="primary" mandatory>
          
          <template v-if="largeScreen">
            <v-chip v-for="(item, i) in tabs" :key="i"
                label
                :dark="tab && tab.name == item.name ? true : false"
                class="text-body-1 mx-0"
                style="background-color: transparent"
                :value="item" @click="gotoTab(item)"
                >{{ item.name }}
              </v-chip>
          </template> 
            <swiper  ref="chipMenu" :options="menuSwiperOptions" v-else>
              <swiper-slide style="width:auto"
                v-for="(item, i) in tabs" class="text-subtitle-1 text-center"
                :key="i"
              >
              <v-chip
                label
                :dark="tab && tab.name == item.name ? true : false"
                class="text-body-1 mx-0"
                style="background-color: transparent"
                :value="item" @click="gotoTab(item)"
                >{{ item.name }}
              </v-chip>
              </swiper-slide>
              <swiper-slide style="width:200px"
              ></swiper-slide>
              </swiper>
            </v-chip-group>
        
        </template>
       
     </v-toolbar>
    </page-header>
    <!--v-alert v-if="message && !allowOrder" :value="message? true: false"  :type="message.type" :color="message.color" :dismissible="!showtakeAway" class="ma-3 ">
                <div v-html="message.text"></div>
              </v-alert-->
       
             
          
           
    <v-container class="main-content mx-auto">
      <v-alert class="ma-5" v-if="host.message"
                    color="orange" outlineds
                    type="info"
                  >{{host.message}}</v-alert> 
    <v-row>
      <v-col :cols="largeScreen ? 8 : 12" class="pl-0 pt-0" :class="{'pt-5' : largeScreen}">
     <!--v-card-text class="pt-10 main-content text-center grey--text" v-html="opentext" v-if="!showSearch && (!tab || tab.favorite)"></v-card-text--> 
    <v-card
     tile
      class="pb-15 pt-3"
      flat
      color="transparent"
      :style="`min-height:calc(100vh - ${$config.page.bannerHeight}px);`"
    > 
    <v-tabs-items v-model="tab" style="background:transparent">
       <v-tab-item :value="tabs[0]">
              
  <v-expand-transition>
 <v-card flat class="mx-0 mt-0" color="primary" dark v-if="!showSearch && (!tab || tab.favorite) && showDetails">
        <v-card-text>
        <v-card-title>{{host.name}} <v-spacer></v-spacer><v-btn icon @click="showDetails=false"><v-icon>close</v-icon></v-btn></v-card-title>
          <v-card-subtitle @click="showAddressBlock=true" v-if="deliver && address && !address.allow">Geen bezorging mogelijk op {{address.name}}</v-card-subtitle>
          <!--v-card-title v-else-if="deliver && address">{{address.name}}</v-card-title-->

        
        <external-link icon="delivery_dining" location class="mr-2" v-if="allowDelivery">
          Bezorgen: <template v-if="address && address.distance>0 && address.allow" icon="pin_drop" class="mr-2">{{address.distance}} km | </template>{{host.delivery.wait}} min 
                <template v-if="address && address.allow"><template v-if="address.price==0"> | gratis</template><template v-else> | {{address.price | toCurrency}}</template></template>
          </external-link><br>
        <external-link v-if="host._address"  :label="'Afhalen op: ' + host.order.wait + ' min'" icon="store" location class="mr-2"></external-link><br>
        <!--external-link v-if="!allowDelivery"  :label="'Geen bezorging'" icon="close" class="mr-2"></external-link><br-->
        <external-link v-if="host._address" v-model="host._address.name" :label="host._address.name" icon="pin_drop" address class="mr-2"></external-link><br>
        <external-link v-model="host.phone" :label="host.phone" icon="support_agent" phone class="mr-2"></external-link>
        <v-card-title>Openingstijden</v-card-title>
    <time-table v-model="host.timetable" card color="primary"></time-table>
    </v-card-text>
     </v-card>
    </v-expand-transition>
       
         <template v-if="loading">
        <v-skeleton-loader
          class="ma-3"
          type="list-item"
          v-for="i in 10"
          :key="i"
        ></v-skeleton-loader>
      </template>
      <template v-else>
       <template v-if="!tab || tab.favorite">
        <template v-if="!searchText && discountlist.length>0">
        <v-card-title class="mt-0 primary--text font-weight-light pl-5"
          >Acties</v-card-title
        >

        <v-list class="pa-0" v-if="discountlist.length>0" :class="{'card-list': largeScreen}">
          <v-divider></v-divider>
          <template v-for="(discount, d) in discountlist">
            <v-list-item :key="'item-' + d" @click="selectDiscount(discount,'takeaway')"
            :disabled="!(discount.deliver === deliver || discount.deliver ===null || (!discount.deliver && discount.deliver!==false))"
            >
              <v-list-item-content>
                <v-list-item-title>{{ discount.name }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="discount.description">{{
                  discount.description
                }}
                
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon v-if="discount.deliver === true">
                <v-icon>delivery_dining</v-icon>
              </v-list-item-icon>
              <v-list-item-icon v-if="discount.deliver === false">
                <v-icon>store</v-icon>
              </v-list-item-icon>
              <v-list-item-action v-if="discount.quantity"
                >{{ discount.pay }}/{{ discount.quantity }}</v-list-item-action
              >
              <v-list-item-action v-else-if="discount.percent"
                >{{ discount.percent }}%</v-list-item-action
              >
              <v-list-item-action v-else-if="discount.price">{{
                discount.price | toCurrency
              }}</v-list-item-action>
            </v-list-item>
            <v-divider :key="d + 'k'"></v-divider>
          </template>
        </v-list>
        </template>
      
        <template v-if="!searchText && favorites.length>0">
           <v-card-title
                class="primary--text font-weight-light pl-5 mt-0"
                >Jouw favorieten</v-card-title
              >
          
          <v-list class="pa-0" v-if="favorites.length>0" :class="{'card-list': largeScreen}">
                <v-divider></v-divider>
                <template v-for="(product, p) in favorites">
                   <product-item :item="product" @select="addFavorite" :key="p" :search="searchText"></product-item>
                  <v-divider :key="p + 'k'"></v-divider>
                </template>
              </v-list>
        </template>
         <v-card-title class="mt-4 primary--text font-weight-light pl-5" v-if="false && searchText && !showSearch"
          >Zoeken op <b class="ml-2">{{searchText}}</b><v-spacer></v-spacer>

          <v-btn icon @click="searchText=null" color="primary"><v-icon>close</v-icon></v-btn>
          </v-card-title
        >
       <template v-if="searchText">
              <v-list class="pa-0" :class="{'card-list': largeScreen}">
                <v-divider></v-divider>
                <template v-for="(product, p) in productlist">
                   <product-item :item="product" @select="showItem" :key="p" :search="searchText"></product-item>
                  <v-divider :key="p + 'k'" v-if="p<9"></v-divider>
                </template>
                 <v-divider></v-divider>
              </v-list>
         </template>
  <template v-else>
       <v-card-title
               v-if="!searchText && top10.length > 0"
                class="primary--text font-weight-light pl-5 mt-0"
                >Populair</v-card-title
              >
              <v-list class="pa-0" v-if="top10.length>0" :class="{'card-list': largeScreen}">
                <v-divider></v-divider>
                <template v-for="(product, p) in top10">
                   <product-item :item="product" @select="showItem" :key="p" :search="searchText"></product-item>
                  <v-divider :key="p + 'k'" v-if="p<9"></v-divider>
                </template>
                 <v-divider v-if="!searchText && top10.length > 0"></v-divider>
              </v-list>
  </template>

     <empty
      :dark="dark"
      v-if="(!showSearch && !searchText) &&  top10.length==0 && favorites.length==0"
      icon="favorite"
      :size="32"
      iconcolor="primary"
      class="ma-3"
     :outlined="true"
      text="Favorieten"
      @click="model='all'"
      :description="`Je hebt nog niet eerder besteld bij ${host.name} en er zijn nog geen favorieten bekend. Selecteer wat je wilt eten.`"
    ></empty>

      <empty :size="32" v-else-if="searchText &&  productlist.length==0 && favorites.length==0" icon="self_improvement" :dark="dark" text="Helaas" :description="`Er zijn geen gerechten gevonden${searchText ? ' met ' + searchText : ''}`">
          
        </empty>
        </template>
      </template>
       </v-tab-item>
         <v-tab-item v-for="(t,tti) in tabs.filter(tt=>tt.groups)" :key="'tab' + tti" :value="t">
           <template v-if="tab && !tab.favorite && largeScreen">
              <v-card-title class="mt-0 primary--text font-weight-light pl-5 pb-0" :class="{'pb-0' : t.groups.length > 1}"
          >{{t.name}}</v-card-title
            >
           </template>
          <template v-for="(group, gi) in t.groups">
              <template v-if="!searchText && tab && t.groups.length > 1 && group != 'label'">
                <v-list-item flat :key="'ss' + group + t.name" class="pa-0 pl-2" :class="{'card-list': largeScreen, 'mt-5' : gi>0}">
                    <v-card-subtitle class="primary--text  link"  :ref="'group' + escape(group)">
                      <template v-for="(item, g) in t.groups"
                      ><span v-if="g>0" :key="'sr' + group + g" class="grey--text font-weight-light mx-1">|</span>
                      <span v-if="item==group" :key="'s' + group + g"
                      @click="$vuetify.goTo(g==0 ? 0 : $refs['group' + escape(item)][0], {duration: 600, offset : 100})"
                      >{{group}}</span>
                      <span v-else label outlined color="transparent" class="grey--text font-weight-light" :key="'s' + group + g"
                      @click="$vuetify.goTo(g==0 ? 0 : $refs['group' + escape(item)][0], {duration: 600, offset : 100})"
                      >{{ item }}</span>
                      </template></v-card-subtitle
                    >
                </v-list-item>
              <!--v-img src="http://static.takeaway.com/images/generic/categories/1_pizza/pizza_americanpizza.png?timestamp=1626714095"></v-img-->
              <!--v-if="!search && productlist.filter(p=>p.tab==t.name && (!p.group || p.group==group))[0] && t.groups.length<2 && productlist.filter(p=>p.tab==t.name && (!p.group || p.group==group))[0].cimage"-->
              </template>
                <v-img :key="'img' + group + t.name" 
                :src="productlist.filter(p=>p.tab==t.name && (!p.group || p.group==group))[0].cimage"
                class="white--text align-end mt-5" :class="{'rounded-lg rounded-b-0' : largeScreen}"

                ></v-img>
              <v-list class="pa-0" :key="'l' + t.name + group" :class="{'card-list': largeScreen}">
                <v-divider v-if="!searchText"></v-divider>
                <template v-for="(item,i)  in productlist.filter(p=>p.tab==t.name && (!p.group || p.group==group))">
                  <product-item :item="item" @select="showItem" :key="i + group" :search="searchText"></product-item>
                  <v-divider :key="i + t + group  + 'k2'"></v-divider>
                </template>
              </v-list>
               
            </template>
        </v-tab-item >
      </v-tabs-items>
    </v-card>
    </v-col>
      <v-col :cols="largeScreen ? 4 : 0" class="mt-5 pr-0">
 
      <!--v-card flat class="rounded-xl pt-15" outlined-->
        <cart 
        v-model="showCart"
        :allow-checkout="allowCheckOut"
        @close="showCart = false"
        @edit="editItem"
        @update="updateItem"
        @comment="commentItem"
        :allow-deliver="allowDelivery"
      >
      
     <v-alert v-if="orderWarning || message"
      outlined
        text slot="info"
        type="info"
        :color="allowCheckOut ? 'grey darken-2' : 'primary'"
        class="rounded-sm mt-5 mx-2 main-content link"  :style="largeScreen ? 'max-width:' +$config.page.columnWidth + 'px' : null"
        @click="showAddressBlock = true;message=null "
       v-html="orderWarning || message.text"></v-alert>   
    
      </cart>
      <v-list dense color="transparent" v-if="!$vuetify.breakpoint.mobile">
        <v-list-item v-for="(item,i) in $config.allergens.filter(item=>allergens.includes(item.value))" :key="i">
          <v-list-item-icon>
            <v-icon v-text="item.icon" :color="item.color"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text" class="label"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </v-col>
      </v-row>
      <v-list dense color="transparent" v-if="$vuetify.breakpoint.mobile">
        <v-list-item v-for="(item in $config.allergens.filter(item=>allergens.includes(item.value))" :key="i">
          <v-list-item-icon>
            <v-icon v-text="item.icon" :color="item.color"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text" class="label"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </v-container>
      <!--/v-card-->
      
      <v-footer flat dark tile class="mt-15" v-if="largeScreen">
           
            <v-container class="mx-auto">
              <v-row>
                <v-col cols="12" md="6">
                <v-card-title class="px-0">{{host.name}}</v-card-title>
                <external-link v-if="host._address" v-model="host._address.name" :label="host._address.name" icon="pin_drop" address class="mr-2"></external-link><br>
                <external-link v-model="host.phone" :label="host.phone" icon="support_agent" phone class="mr-2"></external-link><br>
                <external-link icon="delivery_dining" location class="mr-2" v-if="allowDelivery">
          Bezorgen: <template v-if="address && address.distance>0 && address.allow" icon="pin_drop" class="mr-2">{{address.distance}} km | </template>{{host.delivery.wait}} min 
                <template v-if="address && address.allow"><template v-if="address.price==0"> | gratis</template><template v-else> | {{address.price | toCurrency}}</template></template>
          </external-link><br>
        <external-link v-if="host.order"  :label="'Afhalen op: ' + host.order.wait + ' min'" icon="store" location class="mr-2"></external-link><br>
        <!--external-link v-if="!allowDelivery"  :label="'Geen bezorging'" icon="close" class="mr-2"></external-link><br-->
        <external-link v-if="host._address" v-model="host._address.name" :label="host._address.name" icon="pin_drop" address class="mr-2"></external-link><br>
        
                </v-col>
              <v-col cols="12" md="6">
                 
              
                 <time-table v-model="host.timetable" card dark></time-table>
              <!--v-img :src="'/api/print/qr/order/'+ host._id" :width="150" class="my-3"></v-img-->
                </v-col>
              
              </v-row>
              
            </v-container>
        </v-footer>
      
      <v-expand-transition v-if="!largeScreen">
        <v-footer
          flat
          v-if="cartCount > 0 && !animate"
          fixed
          :elevation="1"
          class="justify-center border-top"
        >
          <v-btn
            text
            class="flex-grow-1"
            @click="showCart = true"
            large
            :class="{ 'primary--text': !dark }"
          >
            <v-badge
              color="red"
              :value="cartCount > 0"
              :content="cartCount"
              class="mr-5"
            >
              <v-icon>shopping_cart</v-icon>
            </v-badge>
            {{ $t("Common.cart") }} ({{ totalAmount | toCurrency }})</v-btn
          >
        </v-footer>
      </v-expand-transition>
    
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../components/PageHeader.vue";
import Cart from "../components/Cart.vue";
import CartFooter from "../components/CartFooter.vue";
import ProductDetail from "../components/ProductDetail.vue";
import ProductItem from "../components/ProductItem.vue";
import headerItem from "@/modules/headerItem";
import AddressBlock from '../components/AddressBlock.vue'
import locationService from "@/modules/locationService";
import tt from "@/modules/timeTable";
import FooterInfo from "../components/FooterInfo.vue";
import empty from '@/components/empty'
import externalLink from '@/components/externalLink'
import featureCard from '../components/feature/featureCard.vue'
import deliveryCostCard from "@/components/feature/deliveryCostCard.vue";
import timeTable from "@/components/feature/timeTable.vue";
let from_url = null
export default {
   metaInfo () {
      return {
        title: `☑ Officiële website ${this.hostitem.name}`,
        meta: [
            { property: 'og:title', content: this.hostitem.feature ? this.hostitem.feature.title :  this.hostitem.name},
            { property: 'og:site_name', content: this.hostitem.name},
            {property: 'og:type', content: 'website'},    
            {name: 'robots', content: 'index,follow'} ,
            { name: 'description', content: this.hostitem.feature ? this.hostitem.feature.description :  this.hostitem.description}
          ]
      }
    },
  mixins: [headerItem, locationService, tt,ProductItem],
  components: {
    PageHeader, AddressBlock,
    Cart,
    CartFooter,
    ProductDetail,
    ProductItem,
    FooterInfo,
    empty,
    externalLink,
    featureCard,
    deliveryCostCard,
    timeTable
  },
  data() {
    return {
      loading: true,
      notfound: false,
      animate: false,
      snackbar: false,
      focusDescription: false,
      showAddressBlock: false,
      product: null,
      showDetails: false,
      window: 0,
      tab: null,
      group: 'Friet',
      searchText: null,
      showSearch: false,
      showCart: false,
      showtakeAway: false,
      cartTransition: 'dialog-bottom-transition',
      showProduct: false,
      timeout: 2000,
      loaded: {},
      tabs: [{ name: "Favoriet", favorite: true }],
      isLoading: false,
      menuSwiperOptions: {slidesPerView: 'auto', spaceBetween: 0, freeMode:true},
      collapseToolbar: false
    };
  },
  computed: {
    ...mapGetters(["authenticated","host","cart", "totalAmount", "cartCount",'cartAmount',  "user", "orders",'config', 'getProducts','courier']),
    from_url(){
      return from_url
    },
    swiper() {
      if (!this.$refs.chipMenu) return false;
      return this.$refs.chipMenu.$swiper;
    },
    backUrl(){
      let location = window.location.host.toString()
      if (this.host && this.host.url && location==this.host.url) return '/organisation/info'
      if (from_url == '/checkout') from_url = '/'
      if (!this.authenticated && from_url) return from_url//'/'+ this.host._id + '/info'
      return '/dashboard'
    },
    isCourier(){
      if (!this.user['#HOSTS']) return false
      return this.user['#HOSTS'].filter(h=>h._id==this.host._id).length>0
    },
    favorite: {
      get() {
        return this.host._favorite || false;
      },
      set(value) {
        this.setHost(Object.assign(this.host,{_favorite:value}))
      },
    },
    showToolbar(){
      return this.isToolbar || this.collapseToolbar
    },
    hostitem() {
      return (
        this.host || {
          banner: this.$config.page.banner,
          name: "Mijn eetplein",
          type: this.$config.menus,
        }
      );
    },
    //tabs() {
    //  return this.hostitem._tabs || [{ name: "Favoriet", favorite: true }];
    //},
    products: {
      get(){
        return this.getProducts
      },
      set(value) {
        this.setProducts(value)
      }
    },
    allergens(){
      const arr = []
      this.products.filter(p=>p.allergens).map(p=>p.allergens.map(a=>arr.push(a)))
      return arr
    },
    discounts() {
      return this.hostitem._discounts || [];
    },
    banner() {
      return this.hostitem.banner;
    },
    title() {
      return this.hostitem.name;
    },
    address: {
      get() {
        return this.$store.state.config.address
      },
      set(value){
        this.setConfig({'address': value})
      }
    },
    needsDetail(){
          if (!this.product) return false;
          let valid = false;
          
          if (
            this.product.volume &&
            this.product.volume.length > 0 &&
            !this.product.$volume
          )
            valid = true;
          if (
            this.product.variation &&
            this.product.variation.length > 0 &&
            !this.product.$variation
          )
            valid = true;
          return valid
    },
    allowDelivery(){
      return this.host.delivery && this.host.delivery.wait &&  this.host.delivery.deliver// && this.address.allow
    },
    isComplete() {
      if (!this.product) return false;
      let valid = true;
     
      let arr = this.product.add || [],
            include = this.product.$include || [];
      arr
        .filter((a) => a.min || a.max)
        .map((a) => {
          let count = include.filter((i) => i.group == a.group).length;
          if (count < a.min || count > a.max) valid = false;
        });
      return !this.needsDetail && valid;
    },
    isCustom() {
      return this.product.add && this.product.add.length > 0;
    },
    top10(){
        return this.host._products.filter((p) => p._sold > 0 && p.tab != "extra").slice(0,10);

    },
    productlist() {
      if (this.showSearch && this.searchText){
        //if (!this.searchText) return []
        return this.products.filter(
          (p) => p.tab!='extra' && 
            p.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .indexOf(this.searchText.toLowerCase().trim()) > -1
        ).sort(this.sortByTabGroup);
      }
      //if (this.tab.favorite)
        return this.products.filter((p) => p.tab != "extra");

      //return this.products.filter((p) => (p.tab == this.tab.name) && 
      //(!this.group || p.group == this.group));
    },
    favorites(){
      return this.host._orders
    },
    deliver(){
        return this.type == "deliver"
    },
    discountlist() {
      var d = new Date();
      var today = d.getDay();
      var deliver = this.deliver
      return this.discounts.filter(
        (d) =>
         // (d.deliver === deliver || d.deliver ===null || (!d.deliver && d.deliver!==false)) &&
          (d.day == today || d.day == -1)
      );
    },

    lastOrder() {
      return this.orders.filter((o) => o._host._id == this.host._id)[0];
    },
    allowOrder() {
      if (this.host && this.host.closed) {
        this.addMessage(this.host.name + ' is <b>Gesloten voor vandaag</b>. Bestellen is niet mogelijk')
        return false
      }
      if (this.startDate.isValid() && !this.firstDate){
        this.addMessage(this.host.name + ' is <b>' + this.opendata.text.toLowerCase() + '</b>. Bestellen is niet mogelijk')
      }
      return this.firstDate ? true : false;
    },
    type: {
      get() {
        return this.$store.state.config.type
      },
      set(value){
        this.setConfig({'type': value})
      }
    },
    allowCheckOut(){
      if (!this.allowOrder) return false
      if (!this.orderWarning) return true
      if (this.address.min> this.cartAmount) return false
      return true
    },
    orderWarning(){
      if (this.type!='deliver' || !this.address || !this.host) return false
      if (this.address && this.address.blocked) return 'Wegens drukte tijdelijk geen gezorging op <br><b>' + this.address.name + '</b>'
      if (this.address && !this.address.allow) return 'Geen bezorging mogelijk op <br><b>' + this.address.name + '</b>'
      if (!this.address || !this.address.allow) return false
      let arr = ['Bezorgen op <b>' + this.address.name + '</b>']
      let conf= this.address || {}
      if (conf.min> this.cartAmount) arr.push('Minimum bedrag voor bezorging is <b>' + this.$options.filters.toCurrency(conf.min) + '</b>')
      if (conf.max> this.cartAmount) arr.push('Gratis bezorgen vanaf <b>' + this.$options.filters.toCurrency(conf.max) + '</b>')
      if (arr.length==1) return false
      return arr.join('<br>')
    }
  },
  async beforeRouteEnter(to, from, next) {
    if (!from) return false
    from_url = from.path
    next();
  },
  async beforeRouteLeave(to, from, next) {
    if (to.name == "checkout" || this.cartCount == 0) return next();
    if (to.name == "login" || this.cartCount == 0) return next();
    if (
      await this.$root.$confirm(
        "Winkelwagen legen?",
        "Als je doorgaat wordt je winkelwagen geleegd, wil je doorgaan?",
        { yes: "Ja", cancel: "Nee" }
      )
    ) {
      this.resetCart()
      next();
    } else {
      next(false);
    }
  },
  mounted() {
    //if (this.$store.state.token) {
      this.load();
      //if ((!this.address || !this.address.allow) && this.allowDelivery) this.showAddressBlock = true
    //}
    //console.log(this.host)
  },
  watch: {
    /*loaded(value){
      if (this.isLoading) return false
      this.isLoading = true
      let size = Object.keys(value).length
      console.log(value, size)
      this.tab = this.tabs[Object.keys(value).length]
      if (this.swiper) this.swiper.slideTo(Object.keys(value).length, 1000, false)
      this.nextTick(()=>{
          this.isLoading = false
      })
    },*/
    showSearch(value){
      if (value) this.tab= this.tabs[0]
    },
    showDetails(value){
      if (value) this.tab= this.tabs[0]
    },
    tab(value) {
       let pos = this.tabs.map(t=>t.name).indexOf(value.name)
       if (this.swiper) this.swiper.slideTo(pos-1, 1000, false)
      //this.search = null;
      //this.group = null
      //this.product = null
      //this.$vuetify.goTo(0,{duration: 300})
      //console.log(value.name,this.$refs['tab' + value.name])
      //if (value && this.$route.query.tab != value) this.$router.push({query: {tab: value.name}})
    },
    deliver(value,old){
      if (!old && value){
       // this.showAddressBlock=this.address && this.address.allow? false:true
      } else{
        this.message = null
        //this.showAddressBlock=false
      }

    },
    address(value){
      this.showAddressBlock = false
      this.checkType()
    },
    searchText(value) {
      if (!value) this.showSearch = false;
    },
    showCart(value){
      if (value===false) this.cartTransition = 'dialog-bottom-transition'
    },
    type (value){
      this.checkType()
    }
  },
  methods: {
    ...mapActions(["setConfig",'resetCart', "setHost","setUser", "addCartItem", "removeCartItem",'setCartItem','setProducts']),
    updateLoaded(t,g,value){
        if (!t) return false
        for (let key in this.loaded){
          this.loaded[key] = false
        }
        this.loaded[t] = true
        let pos = this.tabs.map(t=>t.name).indexOf(t)
        this.tab = this.tabs[pos]
        if (this.swiper) this.swiper.slideTo(pos, 1000, false)
    },
    slideNext(){
      let pos = this.swiper.activeIndex
      this.swiper.slideTo(pos + 5, 1000, false)
    },
    slidePrevious(){
      let pos = this.swiper.activeIndex
      this.swiper.slideTo(pos - 5, 1000, false)
    },
    setThisAddress(addres){
      this.address = addres
    },
    gotoTab(value){
        if (this.$refs['tab' + this.escape(value.name)]){
            this.$vuetify.goTo(this.$refs['tab' + this.escape(value.name)][0], {duration: 600, offset : 100})
            return setTimeout(()=>this.$vuetify.goTo(this.$refs['tab' + this.escape(value.name)][0], {duration: 300, offset : 100}),300)
        }
        this.$vuetify.goTo(0,{duration: 300})
    },
     checkType(){
       if (!this.host || !this.host.timetable) return false
        if (this.type == 'deliver' && !this.allowDelivery) {
          this.addMessage(this.host.name + " bezorgt niet, je kunt je bestelling wel afhalen")
          this.showtakeAway = true
          this.type = "takeaway";
        }
        if ((!this.address || !this.address.allow) && this.type != "takeaway") {
          if (!this.address) this.addMessage('Klik hier om je adres te selecteren of kies voor afhalen')
           if (this.address) this.addMessage('Bezorging is niet mogelijk op <br><b>' + this.address.name + '</b>')
          //this.address = null
          //this.showAddressBlock = true
          this.showtakeAway = true
          //this.type = "takeaway";
        }
        if (!this.firstDate){
          this.addMessage('Bestellen is vandaag niet mogelijk.<br>' + this.opentext)
        }
     },
    async load(search) {
      let location = window.location.host.toString()
      let perma = this.$route.params.index
      try {
        if (window.location.host.toString().split(".")[1] == 'eetplein') perma = location.split(".")[0]
      }catch(e){
        console.log(window.location.host)
      }
      if (this.$route.query && this.$route.query.cart) {
        if (!this.largeScreen) this.showCart = true
        this.cartTransition = 'none'
        delete this.$route.query.cart
      }
      if (
        !this.host ||
        !this.host._tabs ||
        this.host._id == "organisation/" + this.$route.params.index
      ) {
          let response = await this.$http.post("/api/host/info", {
            index: "organisation/" + this.$route.params.index,
            perma: perma,
            url: location
          });
          let host = response.data;
          if (!host || host.error) {
            this.loading = false
            return this.notfound = true
          }
         
          if (this.host) host._stamps = this.host._stamps
          this.tabs = [{ name: "Favoriet", favorite: true }];
          //host.menu.map((m) => host._tabs.push({ name: m }));
          
          this.setHost(host);
          this.setTimeTable(host)

          response = await this.$http.post("/api/host/products", {
            index: this.host._id,
            customer: this.user ? this.user._id : null,
          });
          host._products = response.data;
          let tt = [{ name: "Favoriet", favorite: true }]
          let tabs = groupBy(response.data.filter(p=>p.tab!=='extra'),'tab')
          if (host.menu) host.menu.map((tab) => {
            tabs[tab] = groupBy(tabs[tab], 'group')
            this.tabs.push({name: tab, groups: Object.keys(tabs[tab]) })
           })
          this.products = response.data //.map(product=>this.list.push(product))
           if (this.cartCount > 0 && this.products.filter(p=>p._id==this.cart[0]._id).length==0) {
              if (
                await this.$root.$confirm(
                  "Winkelwagen legen?",
                  "Als je doorgaat wordt je winkelwagen geleegd, wil je doorgaan?",
                  { yes: "Ja", cancel: "Nee" }
                )
              ) {
                this.resetCart()
               
              } else {
                return this.$router.go(-1)
              }
          }
          //host._tabs = tt
          //setTimeout(()=> this.list = host._products,2000);
          response = await this.$http.post("/api/host/discounts", {
            index: this.host._id,
          });
          host._discounts = response.data;
          this.setHost(host);
          this.checkType()
      }
      this.tab = this.tabs[0];
      if (this.$route.query) {
          this.tab = this.tabs.filter(t=>t.name == this.$route.query.tab)[0] || this.tab
          let ref = 0
          if (this.$route.query.tab) ref = 'tab'+ this.$route.query.tab
          
          if (this.$route.query.group) ref = 'group'+ this.$route.query.group
            setTimeout(()=>{
              
              if (this.$refs[this.escape(ref)]) this.$vuetify.goTo(this.$refs[this.escape(ref)][0], {duration: 600, offset : 100})
            }, 2000)
         
      }
      //response = await this.$http.post('/api/host/tabs' , {index: 'organisation/' + this.$route.params.index})
      
      this.loading = false;
      //get address
      this.regions = this.host.regions
      try{
        this.address = this.setAddress(this.regions, this.host._address, this.config['address'] || (this.user ? this.user._address[0] : null))
      }catch(e){

      }
      //if (this.lastOrder) this.type = this.lastOrder.deliver ? 'deliver' : 'takeaway'
      //if (this.isCustomer)
    },
    async toggleCourier() {
      if (!this.isCourier) {
        let response = await this.$http.post(
          "/api/edge/DELIVERS/" + this.host._id,
          { _id: this.user._id, courier: true, date: new Date() }
        );
      } else {
        let response = await this.$http.delete(
          "/api/edge/DELIVERS/" + this.host._id,
          { _id: this.user._id }
        );
      }
       let response = await this.$http.get("/api/auth/me");
        if (!response.data.user) return this.handleLogout();
        this.setUser(response.data.user);
    },
    async toggleFavorite() {
      
      if (!this.favorite) {
        let response = await this.$http.post(
          "/api/edge/CONSUMERS/" + this.host._id,
          { _id: this.user._id, favorite: true, date: new Date() }
        );
      } else {
        let response = await this.$http.delete(
          "/api/edge/CONSUMERS/" + this.host._id,
          { _id: this.user._id }
        );
      }
      this.favorite = !this.favorite;
    },
    selectDiscount(discount, type){
      if (type) this.type = type
      if (discount.tab) this.tab = this.tabs.filter(t=>t.name == discount.tab)[0] || this.tab
      if (discount.group) this.$nextTick(()=>this.group = discount.group)
    },
    addToCart(product, direct) {
      if (!this.allowOrder) return false;
      //this.showProduct = false;
      if (product.tab == 'extra') return false
      this.animate = true;
      this.showCart = this.largeScreen
      this.snackbar = false //this.isCustom && direct;
      this.addCartItem(product);
      setTimeout(
        () => {
          if (!this.showProduct) this.product = null;
          this.animate = false;
        },
        this.snackbar ? this.timeout : 100
      );
    },
    removeFromCart(product) {
      this.showProduct = false;
      this.removeCartItem(product);
    },
    addFavorite(favorite){
      let p = this.products.filter(p=> p._id == favorite._id)[0]
      p.$quantity = 1
      p.count = 1
      p.favorite = true
      this.product = this.calculateProduct(Object.assign(favorite,p))
      this.showItem(this.product)
    },
    isDisabled(product){
      if (!this.product) return false
      if(this.product._id == product._id) return false
      return true
    },
    addExtraItem(product){
      this.addToCart(product, true);
    },
    select(product, expand, expanded){
      this.product = this.clone(product)
      //if (!this.isComplete) 
      if (expand) {
        expand(this.product, !expanded)
        if(expanded) return this.product = null
         this.$nextTick(() =>{
              if (this.$refs['detail-' + product._key]) this.$vuetify.goTo(this.$refs['detail-' + product._key][0],{duration: 300, offset : 110})
          });
        return
      }
      this.showItem(this.product)
    },
    showItem(product, expand) {
      if (!this.allowOrder) return false;
      if (expand) expand(product, false)
      delete product.count
      delete product.$quantity
      this.product = this.clone(product)

      if (this.isComplete && !this.isCustom) return this.addToCart(this.setProduct(this.product), true);
      //if (this.isComplete && !this.isCustom) 
      //this.addToCart(product, true);
      this.snackbar = false;
      this.focusDescription = false
      this.showProduct = !expand ? true : false;
      //this.addCartItem(product)
    },
    addItem(product){
      return this.addToCart(product, true);
    },
    editItem(product) {
      //console.log(product)
      this.focusDescription = false
      this.product = product;
      this.snackbar = false;
      this.showProduct = true;
    },
    updateItem(product){
        return this.setCartItem(product)
    },
    commentItem(product){
      this.focusDescription = true
      this.product = product;
      this.snackbar = false;
      this.showProduct = true;
    },
    sortByTabGroup(a, b) {
       if (b.tab != a.tab) return a.tab > b.tab ? -1 : 1
        if (b.group != a.group) return b.group - a.group
        return a.name < b.name ? -1 : 1
    },
    escape(txt){
      if (!txt) return txt
      return txt.replace(/\'/g,'')
    }
  },
};
var groupBy = function(xs, key) {
  if (!xs) return {}
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};
</script>
<style>
.v-slide-group__prev.v-slide-group__prev--disabled,
.v-slide-group__next.v-slide-group__next--disabled{
  width:10px;
  min-width:10px;
  opacity:0;
  flex: 0;
}
.col-divider{
  border-left:3px solid #0069B3;
}
</style>
